import type { PackageListItem } from '@openx/types/package';
import type { UsePackageUsedByResponse } from '@openx/types/package/PackageHookTypes';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeleteMessageIfUsedBy } from '../getDeleteMessageIfUsedBy';
import { isPackageUsedBy } from '../isPackageUsedBy';

export type GetDeleteActionPermissionsParam = {
  pckg: PackageListItem;
  permissionCheck: (pckg: PackageListItem) => boolean;
  packageUsedBy: UsePackageUsedByResponse;
  notAllowedMsgDefault?: string;
};

export const usePackageDeletePermissions = () => {
  const { t } = useTranslation();

  const getDeleteActionPermissions = useCallback(
    ({ pckg, permissionCheck, packageUsedBy, notAllowedMsgDefault }: GetDeleteActionPermissionsParam) => {
      const hasDeletePermission = permissionCheck(pckg);
      const isPackageUsed = isPackageUsedBy(pckg.uid, packageUsedBy.data);
      const isAllowed = hasDeletePermission && !isPackageUsed.dealsOrFloors;

      const notAllowedMessage = hasDeletePermission
        ? getDeleteMessageIfUsedBy({ t, ...isPackageUsed })
        : notAllowedMsgDefault;

      return { isAllowed, notAllowedMessage: !isAllowed ? notAllowedMessage : undefined };
    },
    [t]
  );

  return { getDeleteActionPermissions };
};
